// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"c071c6ab","455":"492e6b75","644":"314b432e"}[chunkId] + ".chunk.js";
};